import { render, staticRenderFns } from "./TbPaketanTerbuka.vue?vue&type=template&id=5858b28d"
import script from "./TbPaketanTerbuka.vue?vue&type=script&lang=js"
export * from "./TbPaketanTerbuka.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports